import { useImperativeHandle, useRef, useState } from "react";
// import PropTypes from 'prop-types';
import styled from "styled-components";

import FileUploadSvg from "@/assets/upload-cloud.svg";
import { Button } from "@/components";
import colors from "@/styles/colors";

const StyledFileUploadInput = styled.input`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    width: 100%;
`;
const StyledFileUploadIcon = styled.img`
    width: 19px;
    height: 13px;
    margin-right: 8px;
`;

const StyledFileUploadLabel = styled.div`
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${colors.night};
    flex: 1;
`;
const StyledFileUploadContainer = styled.div`
    padding: 0 20px 0 20px;
    position: relative;
    width: 390px;
    height: 59px;
    border-radius: 5px;
    border: solid 1px ${colors.silver};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const StyledFileUploadButton = styled(Button)`
    z-index: 1;
`;

/**
 * File picker with a styled browse button and drop target.
 *
 * @param root0 - The component props. `onSelectFile` receives the chosen `File`
 *   (or `null` when cleared); `ref` exposes a `clean()` handle that resets it.
 * @returns The rendered file upload control.
 */
const FileUpload = ({ onSelectFile, ref }) => {
    const inputElRef = useRef(null);
    const [fileName, setFileName] = useState();
    useImperativeHandle(ref, () => ({
        clean: () => {
            setFileName(null);
            onSelectFile(null);
        },
    }));
    return (
        <StyledFileUploadContainer>
            <StyledFileUploadIcon src={FileUploadSvg} />
            <StyledFileUploadLabel>
                {fileName ? fileName : "Drop files to upload here or"}
            </StyledFileUploadLabel>
            <StyledFileUploadButton
                outlined
                onClick={() => inputElRef.current.click()}
            >
                {"Browse Files"}
            </StyledFileUploadButton>
            <StyledFileUploadInput
                accept="application/JSON"
                ref={inputElRef}
                onClick={(e) => {
                    if (e.isTrusted) e.preventDefault();
                }}
                onChange={() => {
                    if (
                        inputElRef.current.files &&
                        inputElRef.current.files.length > 0
                    ) {
                        const file = inputElRef.current.files[0];
                        setFileName(file.name);
                        onSelectFile(file);
                    }
                }}
                type="file"
            />
        </StyledFileUploadContainer>
    );
};

export default FileUpload;
